import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiComponentOutletDirective } from './fi-component-outlet.directive';

@NgModule({
    imports: [CommonModule],
    declarations: [FiComponentOutletDirective],
    exports: [FiComponentOutletDirective],
})
export class FiComponentOutletModule {}
